import { Link } from "react-router-dom";
import React, { Component } from "react";
import TodayIcon from "@material-ui/icons/Today";
import "../../styles/css/Jobs/AcceptedBidderCard.css";
import StarRateIcon from "@material-ui/icons/StarRate";
import StarRatingComponent from "react-star-rating-component";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const token = localStorage.getItem("token");

class AcceptedBidderCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.starRate = [];
  }

  componentDidMount() {}

  render() {
    const { selectedUserData } = this.props;
    // console.log(selectedUserData);

    return (
      <div className="projectCardRoot">
        <div
          className={
            token && token.length > 0
              ? "projectCardMainLogin desktopDivFlex"
              : "projectCardMain desktopDivFlex"
          }
        >
          <div className="projectCardLeft">
            <AccountCircleIcon className="protractorSvg" />
          </div>
          <div className="projectCardMiddle">
            <div style={{ display: "flex" }}>
              <Link to={"/Profile/" + selectedUserData.survey_id}>
                <p className="projectCardTitle bidCardNameLink">
                  {selectedUserData.survey_name}
                </p>
              </Link>
              <div
                className="projectCardStar"
                style={{ paddingTop: "10px", paddingLeft: "10px" }}
              >
                <StarRatingComponent
                  name="rate1"
                  starCount={5}
                  value={Math.round(selectedUserData.user_rating, 10)}
                  starColor={"#9cd5f1"}
                  emptyStarColor={"#b1b1b1"}
                  renderStarIcon={() => (
                    <StarRateIcon style={{ width: "20px" }} />
                  )}
                  editing={false}
                />
              </div>
            </div>
            <p className="projectCardDesc" id="projectCardDesc">
              {selectedUserData.description}
            </p>
            <div className="projectCardDetails">
              <div className="projectCardStar">
                <TodayIcon />
                <div style={{ padding: "3px" }}>
                  Get done in {selectedUserData.duration} days
                </div>
              </div>
            </div>
          </div>
          <div className="projectCardRight">
            <div className="projectCardCostDiv">
              <div className="projectCardCost">
                <span className="projectCardCostMain">
                  ${selectedUserData.amount.split(".")[0]}
                </span>
                <span className="projectCardCostUnit">&nbsp;USD</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            token && token.length > 0
              ? "projectCardMainLoginMobile mobileDiv"
              : "projectCardMainMobile mobileDiv"
          }
        >
          <div className="projectCardMiddleMobile">
            <Link to={"/Profile/" + selectedUserData.survey_id}>
              <p className="projectCardTitleMobile">
                {selectedUserData.survey_name}
              </p>
            </Link>
            <div className="projectCardStar">
              <StarRatingComponent
                name="rate1"
                starCount={5}
                value={Math.round(selectedUserData.user_rating, 10)}
                starColor={"#9cd5f1"}
                emptyStarColor={"#b1b1b1"}
                renderStarIcon={() => (
                  <StarRateIcon style={{ width: "20px" }} />
                )}
                editing={false}
              />
            </div>
            <p className="projectCardDescMobile" id="projectCardDesc">
              {selectedUserData.description}
            </p>
            <div className="projectCardDetailsMobile">
              <div className="projectCardStarMobile projectCardCalMobile">
                <TodayIcon />
                <div style={{ padding: "3px" }}>
                  Get done in {selectedUserData.duration} days
                </div>
              </div>
            </div>
          </div>
          <div className="projectCardRightMobile">
            <div className="projectCardCostDivMobile">
              <div className="projectCardCostMobile">
                <span className="projectCardCostMainMobile">
                  ${selectedUserData.amount.split(".")[0]}
                </span>
                <span className="projectCardCostUnit">&nbsp;USD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AcceptedBidderCard;



// WEBPACK FOOTER //
// ./src/pages/Jobs/AcceptedBidderCard.js